import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import {FiNavigation} from "react-icons/fi"

const ModalInput = ({
  isOpen,
  onClose,
  header,
  children,
  buttonOnClick,
  loading,
  modalSize,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={modalSize || "2xl"}>
      <ModalOverlay />
      <ModalContent borderRadius="3xl">
        <ModalHeader>{header}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>{children}</ModalBody>
        <ModalFooter>
          <Button
            bg="kasbon.500"
            color="white"
            rounded="full"
            leftIcon={<FiNavigation />}
            _hover={{
              bg: "kasbon.900",
            }}
            _active={{
              bg: "kasbon.500",
            }}
            onClick={buttonOnClick}
            isLoading={loading}
          >
            Submit
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalInput;
